import React, { useState } from 'react';
import { questions } from '../data/questions';
export function PurityTest() {
  const [checkedState, setCheckedState] = useState<boolean[]>(new Array(questions.length).fill(false));
  const [score, setScore] = useState<number | null>(null);
  const [showModal, setShowModal] = useState(false);
  const handleOnChange = (position: number) => {
    const updatedCheckedState = checkedState.map((item, index) => index === position ? !item : item);
    setCheckedState(updatedCheckedState);
  };
  const calculateScore = () => {
    const checkedCount = checkedState.filter(item => item).length;
    const finalScore = 100 - checkedCount;
    setScore(finalScore);
    setShowModal(true);
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  };
  const clearAll = () => {
    if (window.confirm('Are you sure you want to clear your checkboxes?')) {
      setCheckedState(new Array(questions.length).fill(false));
      setScore(null);
      setShowModal(false);
    }
  };
  // Keeping the original logic but removing the LA specific text for the generic vintage version
  // or keeping it simple as per "visual redesign only" instruction, but the text was very specific to the old design.
  // I will use generic purity test text to match the Rice theme.
  const getDescription = (score: number) => {
    return `You scored a ${score}. This score represents the percentage of these items you have NOT done.`;
  };
  return <div className="w-full max-w-4xl mx-auto px-4 py-12 font-serif text-[#2C2416]" data-id="element-4">
      {/* Header Section */}
      <div className="mb-12 text-center relative" data-id="element-5">
        {/* Thresher Logo */}
        <div className="mb-2" data-id="element-6"></div>

        {/* Main Title Area with Decorative Lines */}
        <div className="relative py-4" data-id="element-7">
          {/* Top Lines */}
          <div className="flex flex-col gap-1.5 mb-2 w-full max-w-2xl mx-auto" data-id="element-8">
            <div className="h-0.5 bg-black w-full" data-id="element-9"></div>
            <div className="h-0.5 bg-black w-full" data-id="element-10"></div>
          </div>

          {/* Title and Stamp */}
          <div className="relative flex items-center justify-center py-2" data-id="element-11">
            {/* Red Stamp */}
            <div className="absolute left-1/2 -translate-x-1/2 md:-translate-x-[180px] -rotate-6 z-10" data-id="element-12"></div>

            {/* Main Text */}
            <h1 className="font-['Playfair_Display'] text-5xl md:text-7xl text-black z-0 relative" data-id="element-13">
              Los Angeles Purity Test
            </h1>
          </div>

          {/* Bottom Lines */}
          <div className="flex flex-col gap-1.5 mt-2 w-full max-w-2xl mx-auto" data-id="element-14">
            <div className="h-0.5 bg-black w-full" data-id="element-15"></div>
            <div className="h-0.5 bg-black w-full" data-id="element-16"></div>
            <div className="h-0.5 bg-black w-full" data-id="element-17"></div>
          </div>
        </div>

        {/* Tagline */}

        {/* Intro Text */}
        <div className="max-w-3xl mx-auto space-y-6 text-lg md:text-xl leading-relaxed font-['Crimson_Text']" data-id="element-18">
          <p className="font-bold" data-id="element-19">
            Caution: This is not a bucket list. Completion of all items on this
            test will likely result in death.
          </p>
        </div>
      </div>

      {/* Questions List */}
      <div className="max-w-3xl mx-auto mb-16" data-id="element-20">
        <ol className="list-decimal list-outside ml-6 space-y-1 md:space-y-2 font-['Crimson_Text'] text-lg md:text-xl" data-id="element-21">
          {questions.map((question, index) => <li key={index} className="pl-2" data-id="element-22">
              <label className="flex items-start gap-3 cursor-pointer group hover:bg-black/5 p-1 -ml-1 rounded transition-colors duration-100" data-id="element-23">
                <input type="checkbox" checked={checkedState[index]} onChange={() => handleOnChange(index)} className="mt-1.5 w-5 h-5 border-2 border-black rounded-sm text-[#2C2416] focus:ring-0 focus:ring-offset-0 bg-white checked:bg-[#2C2416] checked:border-[#2C2416] cursor-pointer appearance-none relative checked:after:content-['✓'] checked:after:absolute checked:after:text-white checked:after:text-sm checked:after:left-[3px] checked:after:top-[-1px]" data-id="element-24" />
                <span className={`${checkedState[index] ? 'line-through opacity-60' : ''}`} data-id="element-25">
                  {question}
                </span>
              </label>
            </li>)}
        </ol>
      </div>

      {/* Footer Buttons */}
      <div className="sticky bottom-8 flex flex-col sm:flex-row justify-center gap-4 z-20" data-id="element-26">
        <button onClick={calculateScore} className="px-8 py-3 bg-[#D4E8D4] border-2 border-black rounded-full text-lg font-bold font-['Crimson_Text'] text-black hover:bg-[#c3dec3] active:translate-y-0.5 transition-all shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] hover:shadow-[1px_1px_0px_0px_rgba(0,0,0,1)]" data-id="element-27">
          Calculate My Score!
        </button>

        <button onClick={clearAll} className="px-8 py-3 bg-[#D4E8D4] border-2 border-black rounded-full text-lg font-bold font-['Crimson_Text'] text-black hover:bg-[#c3dec3] active:translate-y-0.5 transition-all shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] hover:shadow-[1px_1px_0px_0px_rgba(0,0,0,1)]" data-id="element-28">
          Clear checkboxes
        </button>
      </div>

      {/* Result Modal */}
      {showModal && score !== null && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setShowModal(false)} data-id="element-29">
          <div className="bg-[#F5F1E8] border-4 border-black p-8 md:p-12 max-w-lg w-full shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] relative" onClick={e => e.stopPropagation()} data-id="element-30">
            <button onClick={() => setShowModal(false)} className="absolute top-4 right-4 text-2xl font-bold hover:opacity-60" data-id="element-31">
              ×
            </button>

            <div className="text-center space-y-6" data-id="element-32">
              <h2 className="font-['UnifrakturMaguntia'] text-4xl" data-id="element-33">
                Your Result
              </h2>

              <div className="w-40 h-40 mx-auto border-4 border-black rounded-full flex items-center justify-center bg-white" data-id="element-34">
                <span className="font-['Playfair_Display'] text-7xl font-bold text-[#C41E3A]" data-id="element-35">
                  {score}
                </span>
              </div>

              <p className="font-['Crimson_Text'] text-xl italic" data-id="element-36">
                {getDescription(score)}
              </p>

              <div className="pt-4" data-id="element-37">
                <button onClick={() => setShowModal(false)} className="px-8 py-2 bg-transparent border-2 border-black text-black font-bold font-['Crimson_Text'] hover:bg-black hover:text-white transition-colors" data-id="element-38">
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>}

      {/* Footer */}
      <div className="mt-16 pt-8 border-t-2 border-black text-center" data-id="element-39">
        <p className="font-['Crimson_Text'] text-lg text-[#2C2416]" data-id="element-40">
          By{' '}
          <a href="https://www.instagram.com/irungracepace" target="_blank" rel="noopener noreferrer" className="font-bold underline hover:opacity-60 transition-opacity" data-id="element-41">
            Grace Ling
          </a>
        </p>
      </div>
    </div>;
}